import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar-header" }
const _hoisted_2 = { class: "sr-only" }
const _hoisted_3 = {
  key: 0,
  id: "notificationBar",
  class: "nav navbar-nav navbar-toggle collapsed toggle-notification-bar"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "nav-menu-item mobile-nav-header"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "23",
  viewBox: "0 0 25 23",
  fill: "none"
}
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "menu-selected-value" }
const _hoisted_14 = { class: "nav navbar-nav menu-list nav-event-dropdown" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "dropdown-menu dropdown-caret dropdown-close event-dropdown-ul" }
const _hoisted_17 = {
  key: 0,
  class: "event-li-position"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href", "title"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "nav navbar-nav hidden-sm hidden-xs menu-list nav-menu-item" }
const _hoisted_22 = { class: "nav navbar-nav navbar-sm" }
const _hoisted_23 = {
  key: 0,
  class: "nav-menu-list nav-menu-border-bottom margin-bottom-10 padding-10"
}
const _hoisted_24 = { class: "change-event-display-name" }
const _hoisted_25 = {
  class: "nav-menu-header non-active-menu-color padding-left-4",
  href: "javascript:void(0)"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = ["href"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "nav-menu-list nav-menu-border-top nav-menu-seperator"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "nav-menu-header non-active-menu-color" }
const _hoisted_32 = {
  key: 2,
  class: "nav-menu-list"
}
const _hoisted_33 = { class: "display-flex-nav navbar-items" }
const _hoisted_34 = ["href"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "nav-menu-header non-active-menu-color" }
const _hoisted_37 = {
  key: 3,
  class: "nav-menu-list"
}
const _hoisted_38 = { class: "display-flex-nav navbar-items" }
const _hoisted_39 = ["href"]
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "nav-menu-header non-active-menu-color" }
const _hoisted_42 = {
  key: 4,
  class: "nav-menu-list"
}
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "nav-menu-header non-active-menu-color" }
const _hoisted_45 = {
  key: 5,
  class: "nav-menu-list nav-menu-border-top nav-menu-seperator"
}
const _hoisted_46 = { class: "display-flex-nav navbar-items" }
const _hoisted_47 = { href: "/Admin/User/IndexUser" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "nav-menu-header non-active-menu-color" }
const _hoisted_50 = {
  key: 6,
  class: "nav-menu-list"
}
const _hoisted_51 = { class: "display-flex-nav navbar-items" }
const _hoisted_52 = ["href"]
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "non-active-menu-color nav-menu-header" }
const _hoisted_55 = {
  key: 7,
  class: "nav-menu-list"
}
const _hoisted_56 = { href: "javascript:void(0)" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "nav-menu-header non-active-menu-color padding-left-0" }
const _hoisted_59 = { class: "navbar-right hidden-sm hidden-xs" }
const _hoisted_60 = { class: "top-nav-settings" }
const _hoisted_61 = {
  key: 0,
  id: "notificationBar",
  class: "nav navbar-nav notification-bar-position"
}
const _hoisted_62 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_63 = ["fill"]
const _hoisted_64 = ["src"]
const _hoisted_65 = {
  id: "helpNavBar",
  class: "nav navbar-nav"
}
const _hoisted_66 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_67 = ["fill"]
const _hoisted_68 = {
  id: "uluserNamedropdownmain",
  class: "nav navbar-nav menu-list"
}
const _hoisted_69 = {
  id: "uluserNamedropdown",
  class: "dropdown-menu user-dropdown"
}
const _hoisted_70 = { class: "logged-in-user-details" }
const _hoisted_71 = { class: "font-weight-600 font-size-16" }
const _hoisted_72 = { class: "font-weight-400" }
const _hoisted_73 = { class: "section-container" }
const _hoisted_74 = { class: "notification-description" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { class: "section-container" }
const _hoisted_77 = ["href"]
const _hoisted_78 = { class: "notification-description" }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "section-container" }
const _hoisted_81 = ["href"]
const _hoisted_82 = { class: "notification-description" }
const _hoisted_83 = { key: 2 }
const _hoisted_84 = { class: "section-container" }
const _hoisted_85 = { class: "notification-description" }
const _hoisted_86 = { class: "menu-logout" }
const _hoisted_87 = { class: "section-container" }
const _hoisted_88 = ["href"]
const _hoisted_89 = { class: "notification-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationPopup = _resolveComponent("NotificationPopup")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", {
      id: "navbar",
      style: _normalizeStyle(_ctx.appAndBackgroundColor),
      class: "navbar navbar-default navbar-fixed-top",
      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.CheckAndHideNotificationPopup()))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "navbar-toggle collapsed",
          type: "button",
          "data-target": "#meetapp-navbar-collapse",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggledNav = !_ctx.toggledNav))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('Togglenavigation')), 1),
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "icon-bar background-white" }, null, -1)),
          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "icon-bar background-white" }, null, -1)),
          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "icon-bar background-white" }, null, -1))
        ]),
        (_ctx.ShowBellIcon() && _ctx.viewModel.ActiveEvent.Id > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
              _createElementVNode("li", {
                id: "noti_Container",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ClickedInsidePopup($event)))
              }, [
                _createElementVNode("div", {
                  id: "noti_Button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ToggleNotificationPopup($event)))
                }, [
                  _createElementVNode("img", { src: _ctx.bellIcon }, null, 8, _hoisted_4),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("img", {
                      src: _ctx.loadingImage,
                      class: "noti_loading"
                    }, null, 8, _hoisted_5), [
                      [_vShow, _ctx.showNotificationLoading]
                    ])
                  ])
                ]),
                _withDirectives(_createVNode(_component_NotificationPopup, {
                  "show-notification-popup": _ctx.notificationPopupVisible,
                  onMouseOverNotification: _cache[2] || (_cache[2] = ($event: any) => (_ctx.MouseOverNotification($event)))
                }, null, 8, ["show-notification-popup"]), [
                  [_vShow, _ctx.notificationPopupVisible]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.HideAppLogo())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.GetCurrentModuleName()), 1)
            ]))
          : (_ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.$EnvironmentBaseURL + '/Admin/Auth/ChangeApplicationInstance',
                class: "navbar-brand"
              }, [
                _createElementVNode("img", {
                  class: "app-logo",
                  src: _ctx.viewModel.ApplicationInformation.LogoUri
                }, null, 8, _hoisted_8)
              ], 8, _hoisted_7))
            : (!_ctx.isOrgSettingsPage)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  href: _ctx.$EnvironmentBaseURL + '/Admin/Auth/ChangeApplicationInstance',
                  class: "navbar-brand"
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                    _createElementVNode("path", {
                      d: "M12.5 0C12.5 0 4.7675 6.82333 0.44625 10.5187C0.1925 10.7538 0 11.0962 0 11.5C0 12.2066 0.55875 12.7778 1.25 12.7778H3.75V21.7222C3.75 22.4288 4.30875 23 5 23H8.75C9.44125 23 10 22.4276 10 21.7222V16.6111H15V21.7222C15 22.4276 15.5588 23 16.25 23H20C20.6912 23 21.25 22.4288 21.25 21.7222V12.7778H23.75C24.4412 12.7778 25 12.2066 25 11.5C25 11.0962 24.8075 10.7538 24.5213 10.5187C20.23 6.82333 12.5 0 12.5 0Z",
                      fill: _ctx.viewModel.ApplicationInformation.TopNavForegroundColor
                    }, null, 8, _hoisted_11)
                  ])),
                  _createElementVNode("img", {
                    class: "app-logo",
                    src: _ctx.viewModel.ApplicationInformation.LogoUri
                  }, null, 8, _hoisted_12)
                ], 8, _hoisted_9))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("nav", {
        id: "meetapp-navbar-collapse",
        class: _normalizeClass(["navbar-collapse collapse", { 'show': _ctx.toggledNav,'collapse': !_ctx.toggledNav}])
      }, [
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("ul", _hoisted_14, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                "data-toggle": "dropdown",
                class: "btn dropdown-toggle event-dropdown-btn margin-right-20",
                style: _normalizeStyle([_ctx.isMobile ? _ctx.appAndBackgroundColor : { color: _ctx.viewModel.ApplicationInformation.TopNavBackgroundColor, background: _ctx.viewModel.ApplicationInformation.TopNavForegroundColor}])
              }, [
                _createElementVNode("img", {
                  class: "logo-round-img event-dropdown-logo",
                  src: _ctx.viewModel.ActiveEvent.ListLogoUrl
                }, null, 8, _hoisted_15),
                _createElementVNode("span", {
                  class: "event-dropdown event-name",
                  style: _normalizeStyle([!_ctx.isMobile ? _ctx.appFontColor : _ctx.appColor])
                }, _toDisplayString(_ctx.viewModel.ActiveEvent.Name), 5),
                _createElementVNode("i", {
                  class: "fa fa-angle-down margin-left-10 font-weight-600 valign",
                  style: _normalizeStyle([!_ctx.isMobile ? _ctx.appFontColor : _ctx.appColor])
                }, null, 4)
              ], 4),
              _createElementVNode("ul", _hoisted_16, [
                (!_ctx.isLoggedInUserEventAdmin)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                      _createElementVNode("a", {
                        href: _ctx.$EnvironmentBaseURL + '/Admin/Auth/CreateNewEventAndNavigate'
                      }, [
                        _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa fa-plus font-size-16" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Addnewevent')), 1)
                      ], 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true),
                _cache[19] || (_cache[19] = _createElementVNode("li", { class: "divider divider-margin" }, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewModel.ActiveEvents, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.Id,
                    class: _normalizeClass(["event-li-position", { active: item.IsActive }])
                  }, [
                    _createElementVNode("a", {
                      href: item.RedirectUrl,
                      class: "event-link",
                      title: item.Name
                    }, [
                      _createElementVNode("img", {
                        class: "hidden-sm hidden-xs",
                        src: item.ListLogoUrl
                      }, null, 8, _hoisted_20),
                      _createTextVNode(" " + _toDisplayString(item.Name), 1)
                    ], 8, _hoisted_19)
                  ], 2))
                }), 128))
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isLeftMenuBarShow && _ctx.viewModel.ActiveEvent.Id > 0]
          ]),
          _createElementVNode("ul", _hoisted_21, [
            _createElementVNode("span", {
              class: _normalizeClass({'menu-name': _ctx.viewModel.ActiveEvent.Id > 0 })
            }, _toDisplayString(_ctx.GetCurrentModuleName()), 3)
          ])
        ]),
        _createElementVNode("ul", _hoisted_22, [
          (_ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[20] || (_cache[20] = _createElementVNode("i", {
                    class: "fa fa-user-circle font-size-16 margin-top-3",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("a", _hoisted_25, _toDisplayString(_ctx.viewModel.LoggedInUserInformation.Firstname) + " " + _toDisplayString(_ctx.viewModel.LoggedInUserInformation.Lastname), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems.MenuItems, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.Id,
              class: _normalizeClass(["nav-menu-list", {'selected-menu-active-border': _ctx.activeComponent === item.ComponentName}]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggledNav = false))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["navbar-items", {'selected-menu-active': _ctx.activeComponent === item.ComponentName}])
              }, [
                (item.IsRouterLink)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { name: item.ComponentName, params: _ctx.routeParams }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.GetImageSrc(item.IconIndex, _ctx.activeComponent === item.ComponentName),
                          class: "nav-menu-img-xs"
                        }, null, 8, _hoisted_26),
                        _createElementVNode("span", {
                          class: _normalizeClass(["nav-menu-header display-inline-block", [_ctx.activeComponent === item.ComponentName ? 'active-menu-color' : 'non-active-menu-color']])
                        }, _toDisplayString(item.Title), 3)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.GetFullExternalUrl(item.Url)
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.GetImageSrc(item.IconIndex, _ctx.activeComponent === item.ComponentName),
                        class: "nav-menu-img-xs"
                      }, null, 8, _hoisted_28),
                      _createElementVNode("span", {
                        class: _normalizeClass(["nav-menu-header display-inline-block", [_ctx.activeComponent === item.ComponentName ? 'active-menu-color' : 'non-active-menu-color']])
                      }, _toDisplayString(item.Title), 3)
                    ], 8, _hoisted_27))
              ], 2)
            ], 2))
          }), 128)),
          (_ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                _createElementVNode("div", {
                  class: "display-flex-nav navbar-items",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.OpenNewsFlash()))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.latestNewsIcon,
                    class: "margin-right-15"
                  }, null, 8, _hoisted_30),
                  _createElementVNode("a", _hoisted_31, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('Latest.News')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLoggedInUserSuperAdmin && _ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("a", {
                    href: _ctx.$EnvironmentBaseURL + 'SuperAdmin/Application'
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.manageAapplicationsIcon,
                      class: "margin-right-15"
                    }, null, 8, _hoisted_35),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('ManageApplications')), 1)
                  ], 8, _hoisted_34)
                ])
              ]))
            : _createCommentVNode("", true),
          (!(_ctx.isLoggedInUserAADAdmin || _ctx.isLoggedinUserOAuthAdmin) && _ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("a", {
                    href: _ctx.$EnvironmentBaseURL + 'Public/ChangePassword/ResetPassword'
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.changePasswordIcon,
                      class: "margin-right-15"
                    }, null, 8, _hoisted_40),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('ChangePassword')), 1)
                  ], 8, _hoisted_39)
                ])
              ]))
            : _createCommentVNode("", true),
          ((_ctx.isLoggedInUserSuperAdmin || _ctx.isLoggedInUserApplicationAdmin) && _ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                _createElementVNode("div", {
                  class: "display-flex-nav navbar-items",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.OpenLicenseDescription()))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.licenceDetailsIcon,
                    class: "margin-right-15"
                  }, null, 8, _hoisted_43),
                  _createElementVNode("a", _hoisted_44, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('License.Details')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("a", _hoisted_47, [
                    _createElementVNode("img", {
                      src: _ctx.inviteCoordinatorIcon,
                      class: "margin-right-15"
                    }, null, 8, _hoisted_48),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('Invite.Administrator')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("a", { href: _ctx.meetappSignoutURL }, [
                    _createElementVNode("img", {
                      src: _ctx.logoutIcon,
                      class: "margin-right-15"
                    }, null, 8, _hoisted_53),
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('Logout')), 1)
                  ], 8, _hoisted_52)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isOrgSettingsPage)
            ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                _createElementVNode("div", {
                  class: "navbar-items user-help-dv",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.OpenHelpLink()))
                }, [
                  _createElementVNode("a", _hoisted_56, [
                    _createElementVNode("img", {
                      src: _ctx.helpIcon,
                      class: "margin-right-15"
                    }, null, 8, _hoisted_57),
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t('Help')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            (_ctx.ShowBellIcon() && _ctx.viewModel.ActiveEvent.Id > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_61, [
                  _createElementVNode("li", {
                    id: "noti_Container",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.ClickedInsidePopup($event)))
                  }, [
                    _createElementVNode("div", {
                      id: "noti_Button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ToggleNotificationPopup($event)))
                    }, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_62, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M22 0C17.6488 0 13.3953 1.29028 9.77746 3.70767C6.15958 6.12506 3.33979 9.56099 1.67466 13.581C0.00953234 17.6009 -0.426141 22.0244 0.422734 26.292C1.27161 30.5596 3.36691 34.4796 6.44366 37.5563C9.52042 40.6331 13.4404 42.7284 17.708 43.5773C21.9756 44.4261 26.3991 43.9905 30.419 42.3253C34.439 40.6602 37.875 37.8404 40.2923 34.2225C42.7097 30.6047 44 26.3512 44 22C44 16.1652 41.6822 10.5695 37.5564 6.44365C33.4306 2.31785 27.8348 0 22 0ZM18.0458 14.6792C19.121 13.604 20.5793 13 22.0999 13C23.6204 13 25.0787 13.604 26.1539 14.6792C27.2291 15.7544 27.8331 17.2127 27.8331 18.7332C27.8331 21.347 28.3918 22.9539 28.8943 23.8751C29.1469 24.3382 29.3908 24.6383 29.5559 24.8125C29.6387 24.8999 29.7023 24.9564 29.7382 24.9863C29.7406 24.9883 29.743 24.9902 29.7451 24.992C29.7511 24.9969 29.756 25.0009 29.76 25.004L29.7693 25.0112C30.1255 25.2579 30.2828 25.7069 30.1568 26.1229C30.0291 26.5446 29.6404 26.8331 29.1997 26.8331H15C14.5593 26.8331 14.1706 26.5446 14.0429 26.1229C13.917 25.7069 14.0742 25.2579 14.4304 25.0112C14.4344 25.0081 14.4451 25 14.4615 24.9863C14.4974 24.9564 14.561 24.8999 14.6438 24.8125C14.8089 24.6383 15.0528 24.3382 15.3054 23.8751C15.8079 22.9539 16.3666 21.347 16.3666 18.7332C16.3666 17.2127 16.9707 15.7544 18.0458 14.6792ZM27.1387 24.8331L27.1385 24.8328C26.4577 23.5846 25.8331 21.6416 25.8331 18.7332C25.8331 17.7431 25.4398 16.7936 24.7396 16.0934C24.0395 15.3933 23.09 15 22.0999 15C21.1097 15 20.1602 15.3933 19.4601 16.0934C18.7599 16.7936 18.3666 17.7431 18.3666 18.7332C18.3666 21.6416 17.742 23.5846 17.0612 24.8328L17.061 24.8331H27.1387ZM21.6001 28.4868C21.323 28.009 20.711 27.8464 20.2333 28.1235C19.7556 28.4007 19.593 29.0126 19.8701 29.4903C20.0967 29.8809 20.4219 30.2052 20.8132 30.4306C21.2046 30.656 21.6482 30.7746 22.0998 30.7746C22.5514 30.7746 22.9951 30.656 23.3864 30.4306C23.7777 30.2052 24.103 29.8809 24.3296 29.4903C24.6067 29.0126 24.4441 28.4007 23.9664 28.1235C23.4886 27.8464 22.8767 28.009 22.5996 28.4868C22.5488 28.5743 22.4759 28.647 22.3882 28.6975C22.3005 28.748 22.201 28.7746 22.0998 28.7746C21.9986 28.7746 21.8992 28.748 21.8115 28.6975C21.7238 28.647 21.6509 28.5743 21.6001 28.4868Z",
                          fill: _ctx.viewModel.ApplicationInformation.TopNavForegroundColor
                        }, null, 8, _hoisted_63)
                      ])),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("img", {
                          src: _ctx.loadingImage,
                          class: "noti_loading"
                        }, null, 8, _hoisted_64), [
                          [_vShow, _ctx.showNotificationLoading]
                        ])
                      ])
                    ]),
                    _withDirectives(_createVNode(_component_NotificationPopup, {
                      "show-notification-popup": _ctx.notificationPopupVisible,
                      onMouseOverNotification: _cache[9] || (_cache[9] = ($event: any) => (_ctx.MouseOverNotification($event)))
                    }, null, 8, ["show-notification-popup"]), [
                      [_vShow, _ctx.notificationPopupVisible]
                    ])
                  ])
                ], 512)), [
                  [_vShow, _ctx.showNotificationIcon]
                ])
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_65, [
              _createElementVNode("li", null, [
                _createElementVNode("div", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.OpenHelpLink();})
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_66, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M22 0C17.6488 0 13.3954 1.29028 9.77747 3.70767C6.15959 6.12506 3.33979 9.56099 1.67467 13.581C0.00953797 17.6009 -0.426136 22.0244 0.422739 26.292C1.27161 30.5596 3.36691 34.4796 6.44367 37.5564C9.52042 40.6331 13.4404 42.7284 17.708 43.5773C21.9756 44.4262 26.3991 43.9905 30.4191 42.3254C34.439 40.6602 37.875 37.8404 40.2923 34.2225C42.7097 30.6047 44 26.3512 44 22C44 16.1652 41.6822 10.5695 37.5564 6.44365C33.4306 2.31785 27.8348 0 22 0ZM22.041 30.643C22.9788 30.643 23.739 29.8828 23.739 28.945C23.739 28.0072 22.9788 27.247 22.041 27.247C21.1032 27.247 20.343 28.0072 20.343 28.945C20.343 29.8828 21.1032 30.643 22.041 30.643ZM22.03 25.064H22.042L22.043 25.065C22.3412 25.0655 22.6274 24.9482 22.8395 24.7386C23.0515 24.529 23.1721 24.2441 23.175 23.946C23.175 23.2444 24.2547 21.893 24.9737 20.9929L24.984 20.98C25.221 20.682 25.444 20.398 25.644 20.135C26.045 19.5907 26.2845 18.9444 26.3353 18.2702C26.386 17.5961 26.2459 16.9212 25.931 16.323C25.5865 15.6064 25.053 14.9974 24.388 14.5616C23.7229 14.1258 22.9516 13.8798 22.157 13.85H22.048C19.511 13.85 17.448 15.634 17.448 17.829C17.448 18.1288 17.5671 18.4164 17.7791 18.6284C17.9911 18.8404 18.2787 18.9595 18.5785 18.9595C18.8783 18.9595 19.1659 18.8404 19.3779 18.6284C19.5899 18.4164 19.709 18.1288 19.709 17.829C19.709 16.898 20.778 16.111 22.087 16.111C22.4693 16.1329 22.8388 16.2568 23.157 16.47C23.4752 16.6832 23.7304 16.9777 23.896 17.323C24.0236 17.5469 24.0856 17.8023 24.0748 18.0598C24.064 18.3173 23.9809 18.5665 23.835 18.779C23.65 19.025 23.439 19.29 23.217 19.568C22.142 20.915 20.924 22.442 20.91 23.923C20.9073 24.2228 21.0238 24.5114 21.2338 24.7253C21.4438 24.9393 21.7302 25.0611 22.03 25.064Z",
                      fill: _ctx.viewModel.ApplicationInformation.TopNavForegroundColor
                    }, null, 8, _hoisted_67)
                  ]))
                ])
              ])
            ]),
            _createElementVNode("ul", _hoisted_68, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  style: _normalizeStyle(_ctx.appColor),
                  "data-toggle": "dropdown",
                  href: "javascript:void(0)",
                  class: "dropdown-toggle name-initial-container"
                }, [
                  _createElementVNode("div", {
                    class: "name-initials",
                    style: _normalizeStyle({'background-color': _ctx.appColor.color})
                  }, [
                    _createElementVNode("span", {
                      class: "nav-bar-initials",
                      style: _normalizeStyle({'color': _ctx.appFontColor.color})
                    }, _toDisplayString(_ctx.GetLoggedInUserNameInitials()), 5)
                  ], 4)
                ], 4),
                _createElementVNode("ul", _hoisted_69, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.viewModel.LoggedInUserInformation.Firstname + ' '+ _ctx.viewModel.LoggedInUserInformation.Lastname), 1),
                      _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('DynamicTextInParentheses', {text: _ctx.viewModel.LoggedInUserInformation.AdminTypeForUpperRightCorner})), 1)
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          id: "newsFlashLink",
                          class: "menuHelp icon-li-link",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => {_ctx.OpenNewsFlash();})
                        }, [
                          _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t('Latest.News')), 1)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.isLoggedInUserSuperAdmin)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              class: "menuHelp icon-li-link padding-left-9",
                              href: _ctx.$EnvironmentBaseURL + 'SuperAdmin/Application'
                            }, [
                              _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('ManageApplications')), 1)
                            ], 8, _hoisted_77)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!(_ctx.isLoggedInUserAADAdmin || _ctx.isLoggedinUserOAuthAdmin))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              class: "menuHelp icon-li-link padding-left-9",
                              href: _ctx.$EnvironmentBaseURL + '/Public/ChangePassword/ResetPassword'
                            }, [
                              _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.$t('ChangePassword')), 1)
                            ], 8, _hoisted_81)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isLoggedInUserSuperAdmin || _ctx.isLoggedInUserApplicationAdmin)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", null, [
                            _createElementVNode("a", {
                              id: "aMyLicense",
                              class: "menuHelp icon-li-link",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.OpenLicenseDescription();})
                            }, [
                              _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t('License.Details')), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", null, [
                        _createElementVNode("a", {
                          class: "menuHelp icon-li-link",
                          href: _ctx.meetappSignoutURL,
                          title: "Sign out meccanappadmin"
                        }, [
                          _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t('Logout')), 1)
                        ], 8, _hoisted_88)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 2)
    ], 4)
  ]))
}